import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import { initBookingForm } from "./scripts/bookingForm";
import { handleFormSuccess } from "./scripts/forms/submission";
import { applyFooter } from "./scripts/config";
import { initReviewCarousels } from "./scripts/reviewCarousel";
import { initReviewLightbox } from "./scripts/reviewLightbox";

// Initialize scroll reveal and tilt effects
initScrollReveal(targetElements, defaultProps);
initTiltEffect();

// Apply footer from config (includes social links)
document.addEventListener("DOMContentLoaded", applyFooter);
document.addEventListener("DOMContentLoaded", () => {
  initReviewCarousels();
  initReviewLightbox();
});

// Initialize booking form when DOM is ready (only if form exists)
function initializePage() {
  // Only initialize booking form if the form exists on this page
  const bookingForm = document.getElementById("bookingForm");
  if (bookingForm) {
    initBookingForm();

    // Add a click listener to the test button
    const testAlertBtn = document.getElementById("test-alert-btn");
    if (testAlertBtn) {
      testAlertBtn.addEventListener("click", () => {
        handleFormSuccess("TEST12");
      });
    }
  }
}

// Use jQuery if available, otherwise use DOMContentLoaded
if (typeof $ !== 'undefined') {
  $(function () {
    initializePage();
  });
} else {
  document.addEventListener("DOMContentLoaded", initializePage);
}
